import { createFileRoute } from '@tanstack/react-router'
import { NotesPage } from '@/components/notes-page'
export const Route = createFileRoute('/archive')({ component: () => <NotesPage view="archive" /> })
